/**
 * /billing/subscriptions — tenant subscription management (PLATBILL-03 PATCH,
 * PLATBILL-04 history, LADM-05 read-only summary).
 *
 * Replaces the placeholder shipped in Plan 06-05. The hub tab strip
 * (BillingHubLayout) keeps working unchanged — this file just swaps the
 * component reference.
 */
import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionsListScreen } from "../features/billing/SubscriptionsListScreen";

export const Route = createFileRoute("/_auth/billing/subscriptions")({
  staticData: {
    breadcrumb: { labelKey: "link-admin:billing.hub.tabs.subscriptions" },
  },
  component: SubscriptionsListScreen,
});
